import { render } from "./Avatar.vue?vue&type=template&id=7f95f6bc"
import script from "./Avatar.vue?vue&type=script&lang=js"
export * from "./Avatar.vue?vue&type=script&lang=js"
script.render = render

export default script